import moment from 'moment';
import 'moment/locale/de';
import 'moment/locale/en-gb';

export class DateHelper {
  static SetLocale(locale: string) {
    moment.locale(locale);
  }

  static LongFormat(date: any) {
    let format = moment.locale() === "de" ? "ddd DD.MM.YYYY" : "ddd MM/DD/YYYY";
    return moment(date).format(format);
  }

  static ShortFormat(date: any) {
    let format = moment.locale() === "de" ? "DD.MM.YYYY" : "MM/DD/YYYY";
    return moment(date).format(format);
  }

  static ToLocalIsoDate(date: Date | string): string {
    return moment(date).format('YYYY-MM-DD[T]00:00:00');
  }
}



// WEBPACK FOOTER //
// ./src/utils/date-helper.ts